module.exports = __webpack_public_path__ + "static/img/pinyin_2x.b41ac51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rehabitation/pinyin_2x.png
// module id = e4PU
// module chunks = 1